import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export const TotalItemsLabel = styled(Typography)(() => ({
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '18px',

  color: NEW_COLORS.GRAYSCALE[400],
}));
